import React, { useEffect, useState } from "react";
import { API, SEARCH_API } from "../../constants/Api";
import { toast } from "react-toastify";
import "./UserBookmarks.css";
import { useNavigate } from "react-router-dom";

function UserBookmarks() {
  const userId = localStorage.getItem("userId");
  const [marks, setMarks] = useState(null);
  const navigate = useNavigate();

  const toDetailPage = async (query) => {
    const toastId = toast.loading("Loading details...");
    const data = "https://www.redfin.com" + query;
    try {
      const response = await fetch(SEARCH_API, {
        method: "POST",
        body: JSON.stringify({ query: data }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const json = await response.json();
        if (json.error) {
          toast.update(toastId, {
            render: "Error! Try again later.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.update(toastId, {
            render: "Successfully loaded!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
          navigate("/listing-detail", { state: { data: json.houses } });
        }
      }
    } catch (error) {
      toast.update(toastId, {
        render: "Failed to load details.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    const getBookmarks = async () => {
      try {
        const response = await fetch(`${API}/user/get-bookmarked/${userId}`);
        const json = await response.json();
        if (response.ok) {
          setMarks(json.homes || []);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };
    getBookmarks();
  }, [userId]);

  return (
    <div className="user-bookmark">
      <h2 className="user-layout-page-heading">Your Bookmarks</h2>
      <div className="container-fluid pt-4 px-0">
        {marks && marks.length > 0 ? (
          <div className="row px-0">
            {marks.map((mark) => (
              <div
                key={mark._id}
                className="col-md-4 px-2 py-2"
                onClick={() => toDetailPage(mark.link)}
                style={{ cursor: "pointer" }}
              >
                <div className="container-fluid user-bookmark-div">
                  <div className="row">
                    <div className="col-12">
                      <img
                        src={mark.images[0] || "/img/placeholder-house.jpg"}
                        className="img-fluid user-bookmark-image"
                        alt=""
                        onError={(e) => {
                          e.target.src = "/img/placeholder-house.jpg";
                        }}
                      />
                    </div>
                    <div className="col-12 pt-2">
                      <span className="user-bookmark-price">${mark.price}</span>
                    </div>
                    <div className="col-12">
                      <span className="user-bookmark-address">{mark.address}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="row px-0">
            <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
              <img
                src="/img/leadership-empty.svg"
                className="img-fluid"
                alt="No bookmarks"
              />
              <h2 className="leadership-empty-heading">It’s Empty Here!</h2>
              <p className="leadership-empty-para mt-2">
                You don’t have any bookmarks at the moment. Start saving your favorite homes!
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserBookmarks;